<template>
  <div>
    <br />
    <DxFileManager
      :file-system-provider="remoteFileProvider"
      :allowed-file-extensions="allowedFileExtensions"
      :on-selected-file-opened="fileManager_onSelectedFileOpened"
      :on-current-directory-changed="onDirectoryChanged"
      :customize-thumbnail="customizeIcon"
      :on-item-moved="onItemMoved"
      :height="550"
      current-path="Documents/Reports"
    >
      <DxPermissions
        :create="true"
        :copy="true"
        :move="true"
        :delete="true"
        :rename="true"
      />

      <DxItemView mode="thumbnails">
        <DxDetails>
          <DxColumn data-field="thumbnail" />
          <DxColumn data-field="name" />
          <DxColumn data-field="dateModified" caption="Modified" />
          <DxColumn data-field="created" caption="Created" data-type="date" />
          <DxColumn
            data-field="modifiedBy"
            caption="Modified By"
            :visible-index="2"
          />
        </DxDetails>
      </DxItemView>
    </DxFileManager>
  </div>
</template>

<script>
import "devextreme/dist/css/dx.light.css";
import {
  DxFileManager,
  DxPermissions,
  DxItemView,
  DxDetails,
  DxColumn,
  DxToolbar,
} from "devextreme-vue/file-manager";
import RemoteFileSystemProvider from "devextreme/file_management/remote_provider";

const remoteFileProvider = new RemoteFileSystemProvider({
  endpointUrl:
    "https://js.devexpress.com/Demos/Mvc/api/file-manager-file-system-images",
  // endpointUrl: "http://localhost:8090/fileremote",
});
const allowedFileExtensions = [];
export default {
  components: {
    DxFileManager,
    DxToolbar,
    DxPermissions,
    DxItemView,
    DxDetails,
    DxColumn,
  },
  data() {
    return {
      remoteFileProvider,
      allowedFileExtensions,
      popupVisible: false,
    };
  },
  methods: {
    fileManager_onSelectedFileOpened(e) {
      console.log("Select file open", e);
    },
    onDirectoryChanged(e) {
      console.log("Directory change", e);
    },
    onItemMoved(e) {
      console.log(`Log out if ${e}`);
      if (e.parentDirectory.name === "Images") {
        console.log(`Log in if ${e.parentDirectory}`);
      }
    },
    customizeIcon(fileSystemItem) {
      if (fileSystemItem.isDirectory) {
        return "https://www.img.in.th/images/c5076072b8addd048044d8fe35b70e31.png   ";
      }

      const fileExtension = fileSystemItem.getFileExtension();
      switch (fileExtension) {
        case ".txt":
          return "https://www.img.in.th/images/aecea561d864a6a62c23ce93a5e5c44b.png";
        case ".rtf":
          return "https://www.img.in.th/images/df6d1c8d00bee9caeadd35d6014a4423.png";
        case ".xml":
          return "https://www.img.in.th/images/75883fbd47f6166d0457e6671478a959.png";
        case ".jpg":
          return "https://www.img.in.th/images/4e4d8f57f6e96bcb9e1932cb79b4b479.png";
        default:
          return "https://www.img.in.th/images/aecea561d864a6a62c23ce93a5e5c44b.png";
      }
    },
  },
};
</script>
